import React, { useContext } from 'react';
import { Collapse, Input, Button, Form, message } from 'antd';
import axios from 'axios';
import AppLayout from "./components/UserLayout";
import { LanguageContext } from "./LanguageContext";
import { locales } from './language';

const { Panel } = Collapse;
const { TextArea } = Input;

const Support = () => {
  const [form] = Form.useForm();
  const { language, setLanguage } = useContext(LanguageContext);
  const t = locales[language];

  const handleSubmit = async (values) => {
    try {
      await axios.post('https://json-configrator-api.root.myoctoopidev.com/Support/Create', {
        title: values.title,
        description: values.description,
        email: values.email
      });
      message.success(t.successMessage || 'Yardım talebiniz başarıyla gönderildi!');
      form.resetFields();
    } catch (error) {
      console.error('Yardım talebi gönderilemedi:', error);
      message.error(t.errorMessage || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  return (
    <AppLayout>
      <>
        <h3>{t.nk}</h3>
        <Collapse accordion>
          <Panel header={t.sae} key="1">
            <p dangerouslySetInnerHTML={{ __html: t.sefeat }} />
          </Panel>
          <Panel header={t.icc} key="2">
            <p dangerouslySetInnerHTML={{ __html: t.bepy }} />
          </Panel>
          <Panel header={t.p3Header} key="3">
            <p dangerouslySetInnerHTML={{ __html: t.p3Content }} />
          </Panel>
          <Panel header={t.p4Header} key="4">
            <p dangerouslySetInnerHTML={{ __html: t.p4Content }} />
          </Panel>
          <Panel header={t.p5Header} key="5">
            <p dangerouslySetInnerHTML={{ __html: t.p5Content }} />
          </Panel>
          <Panel header={t.p6Header} key="6">
            <p dangerouslySetInnerHTML={{ __html: t.p6Content }} />
          </Panel>
          <Panel header={t.p7Header} key="7">
            <p dangerouslySetInnerHTML={{ __html: t.p7Content }} />
          </Panel>
          <Panel header={t.p8Header} key="8">
            <p dangerouslySetInnerHTML={{ __html: t.p8Content }} />
          </Panel>
          <Panel header={t.p9Header} key="9">
            <p dangerouslySetInnerHTML={{ __html: t.p9Content }} />
          </Panel>
        </Collapse>

        <div style={{ marginTop: '40px' }}>
          <h3>{t.ytb}</h3>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{ maxWidth: '600px', margin: '0 auto' }}
          >
            <Form.Item
              label={t.titlee}
              name="title"
              rules={[{ required: true, message: t.titleRequired || 'Başlık alanı zorunludur!' }]}
            >
              <Input placeholder={t.titlee} />
            </Form.Item>

            <Form.Item
              label={t.mail}
              name="email"
              rules={[{ required: true, message: t.mailRequired || 'E-Mail alanı zorunludur!' }]}
            >
              <Input placeholder={t.mail} />
            </Form.Item>

            <Form.Item
              label={t.description}
              name="description"
              rules={[{ required: true, message: t.descriptionRequired || 'Açıklama alanı zorunludur!' }]}
            >
              <TextArea rows={4} placeholder={t.description} />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                {t.tb}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </>
    </AppLayout>
  );
};

export default Support;
